<template>
  <div>
    <WebQuestionEditor
      v-if="codingObjectReady"
      mode="add"
      :codingObject="codingObject"
      @CODING_OBJECT_EMITTED="saveQuestionAndGoBack"
    />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import WebQuestionEditor from "@/components/Web/WebQuestionEditor"

export default {
  components: {
    WebQuestionEditor,
  },
  data() {
    return {
      codingObject: {
        provider_id: null,
        reading_time: null,
        attachments: {},
        created_on: "",
        time_allocated: 0,
        is_bonus: false,
        code_template_file_ids: {},
        id: "",
        qtags: [],
        placeholder_json: {
          data: [],
        },
        test_case_file_input_id: "",
        explain: null,
        content: "Content goes here",
        is_time_bound: true,
        is_required: false,
        type: 9,
        item_cursor: 0,
        topics_questions: "[]",
        is_dependent_ids: "string",
        answers: "string",
        tries: 0,
        submission_cases: [],
        game_config_json: {},
        placeholder: null,
        slug: "",
        test_case_file_output_id: "",
        name: "",
        game_script_file_id: null,
        list: {},
        code_template_file_json: {
          data: [],
        },
        points: 0,
        updated_on: "2018-10-31T11:07:51.709434+00:00",
        author_id: "",
      },
      codingObjectReady: false,
    }
  },
  mounted() {
    this.codingObjectReady = true
  },
  methods: {
    saveQuestionAndGoBack(obj) {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}questions/`,
        data: obj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$router.push("/web-questions/")
      })
    },
  },
}
</script>
